import dayjs from "dayjs";

import {useEffect} from "react";
import {useTranslation} from "react-i18next";

const useDateConfig = () => {
  const {i18n} = useTranslation();

  useEffect(() => {
    const selectedLanguage = i18n.resolvedLanguage === "ger" ? "de" : (i18n.resolvedLanguage ?? "de");

    dayjs.locale(selectedLanguage);
  }, [i18n.resolvedLanguage]);
};

export {useDateConfig};
